const networkErrorMessage =
  "インターネットに接続されていない可能性があります。インターネットに接続して再度お試しください。";
const firestoreUpdateErrorMessage =
  "既に訪問が終了している可能性があります。画面を更新してください。";

export { networkErrorMessage, firestoreUpdateErrorMessage };
